import { useCallback, useRef, useState } from 'react';
import { OptionValue } from '../../../../lib/OptionsLib';
import { UseMultiOptionsSelectorProps } from './useMultiOptionsSelector.types';

const useMultiOptionsSelectorV2 = ({ onChange, value }: UseMultiOptionsSelectorProps) => {
  const [query, setQuery] = useState<string>('');
  const textFieldRef = useRef<HTMLInputElement>(null);

  const handleSelectMultiple = useCallback(
    (optionValue: OptionValue | OptionValue[]) => {
      const optionValues = Array.isArray(optionValue) ? optionValue : [optionValue];
      const newSelectedOptions = optionValues.reduce(
        (acc, currentValue) => {
          if (acc.includes(currentValue)) {
            return acc.filter((v) => v !== currentValue);
          } else {
            return [...acc, currentValue];
          }
        },
        [...value],
      );

      onChange(newSelectedOptions);
    },
    [onChange, value],
  );

  return {
    query,
    onChangeQuery: setQuery,
    textFieldRef,
    handleSelectMultiple,
  };
};

export default useMultiOptionsSelectorV2;
